import { css } from '@emotion/css'
import { spacing, fontWeight, fontSize, borderRadius, fontFamily } from '../../styles'
import getThemeColors, { colors } from '../../themes'

const styles = {
  wrapper: css({
    margin: 0,
    boxSizing: 'border-box',
    borderRadius: borderRadius.small,
    overflow: 'hidden',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  }),

  rounded: css({
    borderRadius: '50%',
    overflow: 'hidden',
  }),

  padded: css({
    '& img': {
      objectFit: 'contain',
    },
  }),

  fallbackInitials: css({
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontWeight: fontWeight.semiBold,
    fontFamily: fontFamily.body,
  }),

  fallbackIcon: css({
    objectFit: 'contain',
    minWidth: '100%',
    minHeight: '100%',

    '& svg': {
      width: '100%',
      height: '100%',
    },
  }),
}

export default styles

export const wrapperSize = (size, padded) => {
  switch (size) {
    case 'extraSmall':
      return css({
        width: 22,
        minWidth: 22,
        height: 22,
        minHeight: 22,
        ...(padded && {
          padding: spacing.extraSmall,
        }),
      })

    case 'small':
      return css({
        width: 30,
        minWidth: 30,
        height: 30,
        minHeight: 30,
        ...(padded && {
          padding: spacing.extraSmall,
        }),
      })

    case 'medium':
      return css({
        width: 60,
        minWidth: 60,
        height: 60,
        minHeight: 60,
        ...(padded && {
          padding: spacing.default,
        }),
      })

    case 'large':
      return css({
        width: 90,
        minWidth: 90,
        height: 90,
        minHeight: 90,
        ...(padded && {
          padding: spacing.small,
        }),
      })

    case 'extraLarge':
      return css({
        width: 125,
        minWidth: 125,
        height: 125,
        minHeight: 125,
        ...(padded && {
          padding: spacing.medium,
        }),
      })

    case 'extraExtraLarge':
      return css({
        width: 150,
        minWidth: 150,
        height: 150,
        minHeight: 150,
        ...(padded && {
          padding: spacing.medium,
        }),
      })

    default:
      return css({
        width: 45,
        minWidth: 45,
        height: 45,
        minHeight: 45,
        ...(padded && {
          padding: spacing.small,
        }),
      })
  }
}

export const wrapperTheme = (theme, modifier) => {
  const themed = getThemeColors(theme)
  return css({
    backgroundColor: modifier === 'dark' ? themed.base : themed.light,
  })
}

export const wrapperColor = color =>
  css({
    backgroundColor: color,
  })

export const imageRender = loaded =>
  css({
    ...(loaded
      ? {
          visibility: 'visible',
        }
      : {
          visibility: 'hidden',
        }),
  })

export const initialsTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    color: colors.white,
    backgroundColor: themed.base,
  })
}

export const initialsSize = size => {
  switch (size) {
    case 'extraSmall':
      return css({
        fontSize: fontSize.extraSmall,
      })

    case 'small':
      return css({
        fontSize: fontSize.small,
      })

    case 'medium':
      return css({
        fontSize: fontSize.medium,
      })

    case 'large':
    case 'extraLarge':
    case 'extraExtraLarge':
      return css({
        fontSize: fontSize.large,
      })

    default:
      return css({
        fontSize: fontSize.default,
      })
  }
}

export const iconTheme = (theme, modifier) => {
  const themed = getThemeColors(theme)
  return modifier === 'dark' ? colors.white : themed.base
}

export const iconSize = size => {
  switch (size) {
    case 'extraSmall':
      return css({
        padding: spacing.extraSmall,
      })

    case 'small':
      return css({
        padding: spacing.extraSmall,
      })

    case 'medium':
      return css({
        padding: spacing.default,
      })

    case 'large':
      return css({
        padding: spacing.medium,
      })

    case 'extraLarge':
      return css({
        padding: spacing.large,
      })

    case 'extraExtraLarge':
      return css({
        padding: spacing.large,
      })

    default:
      return css({
        padding: spacing.small,
      })
  }
}
